import React from "react";
import type { FeedItem } from "@/types/feedItems";
import { Card } from "@/components/ui/card";
import BaseFeedItem from "./BaseFeedItem";

interface FeedItemRendererProps {
  item: FeedItem;
}

const FeedItemRenderer = ({ item }: FeedItemRendererProps) => {
  return (
    <Card className="mb-4 last:mb-0 shadow-sm bg-white dark:bg-gray-800">
      <BaseFeedItem item={item} />
    </Card>
  );
};

export default FeedItemRenderer; 